<app-loader></app-loader>
@if (!hideSiteChrome()) {
  <app-header />
}
<div class="page-content">
  <router-outlet></router-outlet>
</div>
@if (!hideSiteChrome()) {
  <app-footer />
}
